Element  = require("lib/element")
Easie    = require("lib/easie")

class ZoomView extends Backbone.View

  initialize: (@options) ->
    @x = @y = 0
    @getOffset()

    @options.minScale      ?= 0.5
    @options.maxScale      ?= 1.0
    @options.buffer        ?= 0.1
    @options.contentWidth  ?= @offset.width
    @options.contentHeight ?= @offset.height

    @velocity = {}
    @scale = @options.minScale
    @transform()

  events: ->
    "touch:gesture": "onGesture"
    "touch:drag":    "onDrag"
    "touch:dbltap":  "onDoubleTap"

  transform: (isEnd) ->
    { minScale, maxScale, buffer } = @options

    cscale = Math.max(@scale, @options.minScale)
    change = -(@options.minScale - cscale) / cscale

    if isEnd
      @scale    = Math.max Math.min(@scale, maxScale), minScale
      @isZoomed = @scale > minScale

      maxW = @options.contentWidth  / 2 * @scale
      maxH = @options.contentHeight / 2 * @scale

      @x = Math.max Math.min(@x, maxW), -maxW
      @y = Math.max Math.min(@y, maxH), -maxH

      @trigger "zoom", this

    Element.transform @el.firstChild,
      x: @x * change
      y: @y * change
      scale: @scale
      transition: if isEnd then "all 400ms" else "none"

  getOffset: ->
    { top, left, right, bottom, width, height } = @el.getBoundingClientRect()
    @offset = { top, left, right, bottom, width, height }

  set: ({ scale, x, y, transition }) ->
    @scale = scale if scale?
    @x = x if x?
    @y = y if y?
    @transform(transition)

  onDoubleTap: ({ detail }) ->
    { minScale, maxScale, buffer } = @options
    { x, y } = detail

    if @scale is maxScale
      @scale = minScale
    else
      @scale += Math.max (maxScale - minScale) / 2, 0.2

    @x = x * @scale
    @y = y * @scale

    @transform(true)

  onDrag: ({ detail }) ->
    { minScale, maxScale, buffer } = @options
    { x, y, start, state } = detail
    didMove = x isnt start.x or y isnt start.y

    if state is "down"
      window.clearTimeout @momentum
      @origin  = { x: @x - x, y: @y - y }
      @history = []

    else if didMove
      @x = @origin.x + x
      @y = @origin.y + y
      @getVelocity()

      if state is "move"
        @transform(false)

      else if state is "up" and (@velocity.x or @velocity.y)
        timestamp = Date.now()
        duration  = 400
        distance  = 600
        origin    = { @x, @y }

        maxW  = @options.contentWidth  / 2 * @scale
        maxH  = @options.contentHeight / 2 * @scale

        destX = @x - @velocity.x * @scale * distance
        destY = @y - @velocity.y * @scale * distance

        distX = Math.max(Math.min(destX, maxW), -maxW) - origin.x
        distY = Math.max(Math.min(destY, maxH), -maxH) - origin.y

        do repeat = =>
          diff = Math.min(Date.now() - timestamp, duration)

          if diff < duration
            @x = Easie.cubicOut(diff, origin.x, distX, duration)
            @y = Easie.cubicOut(diff, origin.y, distY, duration)

            @transform(false)
            @momentum = window.setTimeout(repeat, 1000 / 60)
          else
            @transform(true)

  onGesture: ({ detail }) ->
    { minScale, maxScale, buffer } = @options
    { x, y, scale, state } = detail

    if state is "start"
      window.clearTimeout @momentum
      @origin =
        x: @x - x
        y: @y - y
        scale: @scale - scale
    else
      @x = @origin.x + x
      @y = @origin.y + y

    min    = minScale - buffer
    max    = maxScale + buffer
    @scale = Math.max Math.min(@origin.scale + scale, max), min

    @transform(state is "end")

  getVelocity: (ms = 200) ->
    now = Date.now()

    @history.push { @x, @y, timestamp: now }

    history = @history.filter (p) -> now - p.timestamp < ms

    [x, y] =
      for dimension in ["x", "y"]
        velocity = history.reduce ((m, p1, i, a) ->
          p2 = a[i - 1] or p1
          m + (p2[dimension] - p1[dimension])
        ), 0

        velocity / (now - history[0].timestamp)

    @velocity = { x, y }

module.exports = ZoomView
